import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import _ from 'lodash';
import PasswordStrengthBar from 'react-password-strength-bar';
import classes from './changePasswordModal.module.scss';
import Modal from '../../../_common/Modal/Modal';
import InputField from '../../../_common/Form/TextFields/InputField';
import Button from '../../../_common/Form/Buttons/Button';
import Api from '../../../../api/api';

function TeamChangePasswordModal({
  onClose, userId, isOpen,
}) {
  const [passwordData, setPasswordData] = useState({
    password: '',
    confirmpw: '',
  });
  const { password, confirmpw } = passwordData;

  const [passwordStrength, setPasswordStrength] = useState('');

  const [error, setError] = useState('');

  const [requiredError, setRequiredError] = useState({
    password: false,
    confirmpw: false,
  });

  const [saveLoading, saveLoadingToggle] = useState(false);

  const changeData = (path, value) => {
    setPasswordData((prev) => ({ ...prev, [path]: value }));
    setRequiredError((prev) => ({ ...prev, [path]: false }));
    setError('');
  };

  const close = () => {
    onClose();
    setPasswordData({ password: '', confirmpw: '' });
    setRequiredError({ password: false, confirmpw: false });
    setError('');
    setPasswordStrength('');
  };

  const submitChangePassword = async (e) => {
    e.preventDefault();

    const sendData = { ...passwordData };

    if (!password || !confirmpw) {
      _.forEach(sendData, (val, key) => {
        if (!val) setRequiredError((prev) => ({ ...prev, [key]: true }));
      });

      setError('Please fill this fields');

      return;
    }

    if (passwordStrength <= 1) {
      setError('Password is too week');
      setRequiredError((prev) => ({ ...prev, password: true }));

      return;
    }

    if (password !== confirmpw) {
      setError('Passwords do not match');
      setRequiredError((prev) => ({ ...prev, confirmpw: true }));

      return;
    }

    try {
      saveLoadingToggle(true);
      await Api.setNewPasswordAdmin({ userId, password });
      toast.success('Password successfully changed');

      close();
    } catch (err) {
      console.warn(err);

      toast.error(err.response?.data?.message || 'Something went wrong');
    }

    saveLoadingToggle(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={!saveLoading ? close : () => {}}
      className={classes.set_password_modal}
    >
      <h3 className={classes.title}>Set New Password</h3>

      <form onSubmit={submitChangePassword}>
        <div className={classes.inputs_wrapper}>
          <div>
            <InputField
              label="Password"
              value={password}
              type="password"
              onChange={(value) => changeData('password', value)}
              error={requiredError.password}
            />

            {password && (
              <PasswordStrengthBar
                className={classes.password_strength_bar}
                onChangeScore={setPasswordStrength}
                password={password}
                minLength={8}
              />
            )}
          </div>

          <InputField
            label="Confirm password"
            type="password"
            value={confirmpw}
            className="w-100"
            onChange={(value) => changeData('confirmpw', value)}
            error={requiredError.confirmpw}
          />

          {error && <div className={classes.error}>{error}</div>}
        </div>

        <Button
          title="Confirm"
          className={classes.btn}
          type="submit"
          loading={saveLoading}
        />
      </form>
    </Modal>
  );
}

TeamChangePasswordModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default TeamChangePasswordModal;
